<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-13",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 13,
      nextPage: '/questionnaire/section2',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Pregnancy.png'),
        mainTitle: 'Do you suffer from consipation?',
        btn: [
          [
            {
              text: 'Yes',
            },{
              text: 'No',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
